<template>
  <div class="signin_page modal_card">
    <div class="signin_form modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Войдите в учетную запись</h1>
      <form @submit.prevent="login">
        <b-field
          label="Логин:"
          type="is-info"
          class="login_input has_icon"
          :message="errors.first('email')"
          :class="errors.first('email') ? 'error' : ''"
        >
          <!-- <b-input 
                        icon="mdi mdi-account-tie" 
                        name="email" 
                        type="text" 
                        placeholder="Email" 
                        v-model="user.email"
                        v-validate="{required: true, email: true, regex: /^[^а-яА-Я]+@([^а-яА-Я]+\.)+[^а-яА-Я]{2,}$/ }"></b-input> -->
          <b-input
            icon="mdi mdi-account-tie"
            name="email"
            type="text"
            placeholder="Email"
            v-model="user.email"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <b-field
          label="Пароль:"
          type="is-info"
          class="password_input has_icon"
          :message="errors.first('password')"
          :class="errors.first('password') ? 'error' : ''"
        >
          <b-input
            icon="mdi mdi-lock"
            name="password"
            type="password"
            placeholder="Пароль"
            v-model="user.password"
            v-validate="{ regex: /^[^а-яА-Я]/, required: true, min: 8, max: 24 }"
          ></b-input>
        </b-field>
        <button class="signin_button modal_button" type="submit" :disabled="errors.items.length > 0">Войти</button>
      </form>
      <p class="forget_button" @click="$emit('open-modal')">Забыли пароль?</p>
    </div>
  </div>
</template>

<script>
import Echo from 'laravel-echo'
import { toastInfo } from '@/lib/toastCfg'
import { config } from '@/config'

export default {
  data() {
    return {
      user: {
        email: '',
        password: ''
        // email: 'admin@gmail.com',
        // password: 'password',
        // email: 'parkour20_99@mail.ru',
        // password: 'arty608209',
      },
      dict: {
        custom: {
          email: {
            required: 'Поле не заполнено',
            email: 'Неверный формат',
            regex: 'Логин должен состоять из латинских букв'
          },
          password: {
            required: 'Поле не заполнено',
            min: 'Слишком короткий пароль',
            max: 'Слишком длинный пароль',
            regex: 'Пароль должен состоять из латинских букв и цифр'
          }
        }
      }
    }
  },
  computed: {
    config() {
      return config
    }
  },
  methods: {
    loadCategories() {
      this.$axios2
        .get('categories')
        .then((resp) => {
          this.$store.commit('setCategoriesList', { list: resp.data })
          this.$axios2
            .get('courses/list?category_id=' + resp.data[0].id)
            .then((response) => {
              this.$store.commit('setCategoryCoursesList', {
                list: response.data,
                index: 0
              })
            })
            .catch(this.$errorToast)
        })
        .catch(this.$errorToast)
      this.$axios2
        .get('categories?all=true')
        .then((resp) => {
          this.$store.commit('setModalCategoriesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    login() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.$axios
          .post('auth', { email: this.user.email, password: this.user.password })
          .then((resp) => {
            const currentRole = resp.data.data.role[0]
            const token = resp.data.data.token
            localStorage.setItem('user-token', token)
            this.$axios.defaults.headers.common['Authorization'] = 'Bearer' + token
            this.$axios2.defaults.headers.common['Authorization'] = 'Bearer' + token
            this.$store.commit('AUTH_LOGIN', { token: token, role: resp.data.data.role })
            this.$emit('close-modal')
            this.$axios2.get('profile').then((response) => {
              this.$store.commit('SET_CURRENT_USER', { user: response.data })
              if (!this.$browserDetect.isIE) {
                window.Echo = new Echo({
                  broadcaster: 'socket.io',
                  host: config.echoApirl,
                  encrypted: true,
                  auth: {
                    headers: {
                      Authorization: 'Bearer ' + token
                    }
                  }
                })
                window.Echo.private(`App.User.${response.data.id}`).notification((notification) => {
                  this.$buefy.toast.open(toastInfo(notification.message))
                })
              }
            })
            this.$axios2
              .get('notifications?unread')
              .then((resp) => {
                this.$store.commit('setUnreadNotificationsList', { list: resp.data })
              })
              .catch(this.$errorToast)
            if (currentRole === 'user') {
              this.$router.push('/my-courses')
              return
            }
            this.$router.push('/profile')
            if (currentRole !== 'admin') return
            this.loadCategories()
          })
          .catch((err) => {
            localStorage.removeItem('user-token')
            this.$store.commit('AUTH_LOGOUT', err)
            this.$errorToast(err)
          })
      })
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
